/* Monzzaro preorder (plan §D.3 / §D.6; v391 paid deposit, founders 19 Sep 2026). One file for the
   static draft AND the theme (theme/assets/mz-preorder.js is a byte-identical copy).

   The deal: a deposit holds the bottle (form data-d60 / data-d20: ₹200 / ₹100), refundable until
   dispatch; at dispatch the customer pays round(MRP x 0.95) - deposit. Every amount on the page is
   painted here from an element's data-tpl ({deposit} / {balance}) and the live price, never typed.

   STATIC SITE: it cannot take money. On a valid submit it logs the payload, keeps it in
   localStorage['mz-preorder'] and shows the "preordered" state (marked as a preview).
   THEME (form[data-cart]): each perfume <option> carries its reservation variant ids and stock
   (data-r60 / data-r20, data-a60 / data-a20). A valid submit adds that variant to the cart with the
   customer's details as line-item properties, then goes to /checkout, where the deposit is paid.

   PDPs: the form (not .always) stays collapsed on load, even with #preorder in the URL; a #preorder
   link scrolls to the CTA, and clicking the CTA ([aria-controls="preorder"]) opens the form in place. */
(function () {
  var MSG = {
    name: 'Enter your name.',
    email: 'Enter a valid email address.',
    mobile: 'Enter a 10-digit Indian mobile number.',
    perfume: 'Choose a perfume.',
    size: 'Choose a size.',
    whatsapp: 'Tick the WhatsApp line to preorder.',
    out: 'Reserved out for this restock.',
    closed: 'Preorders for this bottle are not open yet.',
    fail: 'That did not go through. Try again, or write to care@monzzaro.com.'
  };
  var ORDER = ['name', 'email', 'mobile', 'perfume', 'size', 'whatsapp'];
  var still = function () { return matchMedia('(prefers-reduced-motion: reduce)').matches; };

  function qs(k) { try { return new URLSearchParams(location.search).get(k); } catch (e) { return null; } }
  function read() { try { return JSON.parse(localStorage.getItem('mz-preorder') || 'null'); } catch (e) { return null; } }
  function write(v) { try { v ? localStorage.setItem('mz-preorder', JSON.stringify(v)) : localStorage.removeItem('mz-preorder'); } catch (e) {} }

  // "₹3,519", "₹3,519.00" or "Rs. 3,519.00" -> 3519
  function amount(s) { var m = String(s || '').match(/\d[\d,]*(\.\d+)?/); return m ? Math.round(parseFloat(m[0].replace(/,/g, ''))) : 0; }
  function rs(n) { return '₹' + n.toLocaleString('en-IN'); }
  function balance(mrp, dep) { return Math.round(mrp * 95 / 100) - dep; }   // 5% off the full price, less the deposit
  // paint one [data-tpl] element; a {balance} needs a price, so without one the element empties
  function paint(el, dep, mrp) {
    if (!el) return;
    var tpl = el.getAttribute('data-tpl');
    el.textContent = (mrp || tpl.indexOf('{balance}') < 0) ? tpl.replace('{deposit}', rs(dep)).replace('{balance}', rs(balance(mrp, dep))) : '';
  }

  // The perfume this page is about: a PDP (static pdp-hero-<handle>.html, pdp-hero.html = Rose
  // O'Clock; theme /products/<handle>), else nothing.
  function pagePerfume(form) {
    if (form.dataset.perfume) return form.dataset.perfume;
    var p = location.pathname, m = p.match(/pdp-hero-([a-z0-9-]+)\.html/) || p.match(/\/products\/([^\/?#]+)/);
    if (m) return m[1];
    return /pdp-hero\.html$/.test(p) ? 'rose-oclock' : '';
  }

  function hasOption(sel, v) { return !!(sel && v && sel.querySelector('option[value="' + v + '"]')); }

  function init(form) {
    var f = function (k) { return form.querySelector('[data-pre="' + k + '"],[name="' + k + '"]'); };
    var el = {}; ORDER.forEach(function (k) { el[k] = f(k); });
    var cart = form.hasAttribute('data-cart');
    var always = form.classList.contains('always');
    var done = form.nextElementSibling && form.nextElementSibling.classList.contains('pre-done') ? form.nextElementSibling : null;
    var submit = form.querySelector('[type="submit"]');
    var msg = form.querySelector('.pre-msg');
    if (!msg && submit) { msg = document.createElement('p'); msg.className = 'pre-msg'; msg.setAttribute('role', 'alert'); submit.parentNode.insertBefore(msg, submit); }
    var sizes = document.getElementById('pvSizes');
    var controls = [].slice.call(document.querySelectorAll('[aria-controls="' + form.id + '"]'));
    var here = pagePerfume(form);
    var wanted = qs('perfume') || here;
    var dep = function (sz) { return +form.getAttribute('data-d' + sz) || 0; };
    var saved = null;   // static: a preorder already made, shown when the CTA opens the form

    // prefill: ?perfume= / this page's perfume; ?size= / the active size button
    if (hasOption(el.perfume, wanted)) el.perfume.value = wanted;
    var sz = qs('size');
    if (!hasOption(el.size, sz) && sizes) {
      var act = sizes.querySelector('button.active');
      sz = act ? (act.dataset.size || act.textContent).replace(/\D/g, '') : '';
    }
    if (hasOption(el.size, sz)) el.size.value = sz;

    function opt() { return el.perfume && el.perfume.options[el.perfume.selectedIndex]; }
    // a size's price: from the chosen perfume's data-p60/data-p20, else (on its own PDP) the size buttons
    function priceFor(v) {
      var o = opt();
      if (o && o.dataset['p' + v]) return o.dataset['p' + v];
      if (sizes && el.perfume && el.perfume.value === here) {
        var b = sizes.querySelector('button[data-size="' + v + '"]');
        if (b && b.dataset.price) return b.dataset.price;
      }
      return '';
    }
    // theme: is the reservation for this perfume + size open, and not yet taken?
    function state() {
      if (!cart) return '';
      var o = opt(), v = el.size && el.size.value;
      if (!o || !o.value) return '';
      if (!o.dataset['r' + v]) return 'closed';
      return o.dataset['a' + v] === 'false' ? 'out' : '';
    }
    function sync() {
      if (el.size) [].forEach.call(el.size.options, function (o) {   // "60 ml · ₹3,519"
        if (!o.dataset.base) o.dataset.base = o.textContent;
        var p = priceFor(o.value);
        o.textContent = o.dataset.base + (p ? ' · ' + p : '');
      });
      var v = el.size ? el.size.value : '60';
      [].forEach.call(form.querySelectorAll('[data-tpl]'), function (n) { paint(n, dep(v), amount(priceFor(v))); });
      var s = state();
      if (submit) submit.disabled = !!s;
      if (msg && (s || msg.dataset.state)) { msg.textContent = s ? MSG[s] : ''; msg.dataset.state = s; }
    }
    // the PDP rail: CTA label + deposit/balance line follow the active size button
    function rail() {
      if (!sizes || document.body.dataset.stock !== 'preorder') return;
      var b = sizes.querySelector('button.active') || sizes.querySelector('button');
      if (!b) return;
      var v = (b.dataset.size || b.textContent).replace(/\D/g, '');
      [].forEach.call(document.querySelectorAll('[data-pre-rail]'), function (n) { paint(n, dep(v), amount(b.dataset.price)); });
    }
    sync(); rail();
    if (el.perfume) el.perfume.addEventListener('change', sync);
    if (el.size) el.size.addEventListener('change', sync);
    if (sizes) sizes.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) return;
      var v = (b.dataset.size || b.textContent).replace(/\D/g, '');
      if (hasOption(el.size, v)) el.size.value = v;
      setTimeout(function () { sync(); rail(); }, 0);   // the PDP script moves .active on the same click
    });

    function digits() {
      var d = (el.mobile && el.mobile.value || '').replace(/\D/g, '');
      if (d.length === 12 && d.indexOf('91') === 0) d = d.slice(2);
      if (d.length === 11 && d.charAt(0) === '0') d = d.slice(1);
      return d;
    }
    function clear() {
      form.querySelectorAll('.err').forEach(function (n) { n.classList.remove('err'); });
      form.querySelectorAll('[aria-invalid]').forEach(function (n) { n.removeAttribute('aria-invalid'); });
      if (msg) { msg.textContent = ''; msg.dataset.state = ''; }
    }
    function bad(k) {
      var n = el[k];
      (k === 'mobile' ? (n.closest('.tel-wrap') || n) : k === 'whatsapp' ? (n.closest('label') || n) : n).classList.add('err');
      n.classList.add('err');
      n.setAttribute('aria-invalid', 'true');
      if (msg) msg.textContent = MSG[k];
      n.focus();
    }
    function nameOf() { var o = opt(); return o ? o.text.replace(/\s*·.*$/, '') : ''; }

    function showDone(p) {
      if (!done) return;
      var set = function (a, v) { var n = done.querySelector('[' + a + ']'); if (n) n.textContent = v; };
      set('data-done-what', p.perfumeName + ', ' + p.size + ' ml');
      set('data-done-dep', rs(p.deposit || dep(p.size)));
      set('data-done-email', p.email);
      set('data-done-mobile', p.mobile.slice(3, 8) + ' ' + p.mobile.slice(8));
      if (!done.querySelector('.pre-change')) {
        var c = document.createElement('button');
        c.type = 'button'; c.className = 'pre-change'; c.textContent = 'Change';
        c.addEventListener('click', function () { write(null); done.hidden = true; form.hidden = false; form.classList.add('open'); });
        done.appendChild(c);
      }
      form.hidden = true; done.hidden = false;
    }

    // open in place (PDP): the form, or the saved "preordered" state; then bring it into view
    function expand() {
      var tgt = form;
      if (saved) { showDone(saved); saved = null; }
      if (form.hidden && done && !done.hidden) tgt = done;
      else form.classList.add('open');
      controls.forEach(function (c) { c.setAttribute('aria-expanded', 'true'); });
      tgt.scrollIntoView({ behavior: still() ? 'auto' : 'smooth', block: 'center' });
      var n = tgt === form && form.querySelector('input,select');
      if (n) n.focus({ preventScroll: true });
    }
    form._mzExpand = expand;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      clear();
      if (el.mobile) el.mobile.value = digits();
      for (var i = 0; i < ORDER.length; i++) {
        var k = ORDER[i], n = el[k]; if (!n) continue;
        var ok = n.checkValidity() && (k !== 'mobile' || /^[6-9]\d{9}$/.test(n.value)) && (k !== 'name' || n.value.trim());
        if (!ok) { bad(k); return; }
      }
      var mrp = amount(priceFor(el.size.value)), d = dep(el.size.value);
      var p = {
        name: el.name ? el.name.value.trim() : '',
        email: el.email.value.trim(),
        mobile: '+91' + el.mobile.value,
        perfume: el.perfume.value, perfumeName: nameOf(),
        size: el.size.value,
        deposit: d,
        balance: mrp ? balance(mrp, d) : 0,
        whatsapp: el.whatsapp && el.whatsapp.checked ? 'yes' : 'no',
        ts: new Date().toISOString()
      };
      if (cart) {   // theme: the reservation variant to the cart, then Shopify checkout takes the deposit
        var s = state();
        if (s) { sync(); return; }
        var o = opt(), root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        var props = { Name: p.name, Email: p.email, Mobile: p.mobile, 'WhatsApp opt-in': p.whatsapp + ', ' + p.ts.slice(0, 10) };
        if (p.balance) props['Balance at dispatch'] = rs(p.balance);
        submit.disabled = true;
        fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: +o.dataset['r' + p.size], quantity: 1, properties: props }] })
        }).then(function (r) {
          if (r.ok) { location.href = root + 'checkout'; return; }
          submit.disabled = false;
          if (r.status === 422) { o.dataset['a' + p.size] = 'false'; sync(); } else if (msg) msg.textContent = MSG.fail;
        }).catch(function () { submit.disabled = false; if (msg) msg.textContent = MSG.fail; });
        return;
      }
      console.log('[mz preorder] preview only, the live store takes the deposit here', p);
      write(p);
      showDone(p);
    });

    // static: a bottle already preordered (for this page's perfume, or any on /epos and /preorder)
    if (!cart) {
      var s = read();
      if (s && s.email && (!wanted || s.perfume === wanted)) { if (always) showDone(s); else saved = s; }
    }
    // collapsed on load, whatever the URL says: #preorder only scrolls to the CTA
    if (!always && location.hash === '#' + form.id && controls[0]) {
      setTimeout(function () { controls[0].scrollIntoView({ block: 'center' }); }, 0);
    }
  }

  // any same-page link to #preorder opens the form in place instead of jumping to it
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href$="#preorder"]');
    if (!a || a.pathname.replace(/\/$/, '') !== location.pathname.replace(/\/$/, '')) return;
    var form = document.getElementById('preorder');
    if (!form || !form._mzExpand) return;
    e.preventDefault();
    form._mzExpand();
  });

  function boot() { document.querySelectorAll('form.pre-form').forEach(init); }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', boot) : boot();
})();
